import '@descope-ui/descope-link';

import { componentName, EnrichedTextClass } from './EnrichedTextClass';

customElements.define(componentName, EnrichedTextClass);

export { EnrichedTextClass, componentName };
